export const TEXT_CONTENT =
  'Eine der zentralen Fragen im Bewerbungsgespräch <strong>dreht sich um das Thema Gehalt</strong>, insbesondere bei Positionen mit einer festgelegten Gehaltsspanne. Wie Du in dieser Hinsicht das Beste für Dich herausholen kannst, verraten wir Dir in unserem informativen Video.';
